var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 95,
    viewBox: "0 0 97 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.1937 39.0238C91.7229 41.7678 92 44.6015 92 47.5C92 72.0767 72.0767 92 47.5 92C22.9233 92 3 72.0767 3 47.5C3 22.9233 22.9233 3 47.5 3C56.9546 3 65.7206 5.94854 72.9286 10.9762M91.9985 15.7153L47.4984 60.2153L28.427 41.1439",
    stroke: "#1AFD90",
    strokeWidth: 6,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c3ad192832f7069094e34f377ead93f6.svg";
export { ForwardRef as ReactComponent };